import { COLORS } from "components/consts";
import { SIDEBAR_DIMENSIONS } from "./consts";

export const listItemStyles = (isOpen: boolean, my: string = "4px") => ({
    display: 'grid',
    justifyContent: !isOpen ? 'center' : 'flex-start',
    py: 0,
    my,
    ...(isOpen && { pl: 0 })
});

export const listItemButtonStyles = (isOpen: boolean, isSelected?: boolean) => ({
    display: 'block',
    justifyContent: 'center',
    borderRadius: 2,
    marginLeft: isOpen ? SIDEBAR_DIMENSIONS.MARGIN_LEFT : '',
    "&.Mui-selected": {
        backgroundColor: "background.default",
        width: isOpen ? SIDEBAR_DIMENSIONS.OPEN_WIDTH : SIDEBAR_DIMENSIONS.CLOSED_WIDTH,
        "& svg": {
            color: "primary.main",
        },
        ":hover": {
            backgroundColor: "background.default",
        },
    },
    "&.Mui-focusVisible": {
        backgroundColor: "background.default",
    },
    ":hover": {
        backgroundColor: "transparent",
        color: isSelected ? null : "primary.main",
        "& svg": {
            color: "primary.main",
        },
    },
});

export const iconContainerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

export const listItemIconStyles = (isOpen: boolean) => ({
    justifyContent: "center",
    minWidth: isOpen ? SIDEBAR_DIMENSIONS.ICON_MIN_WIDTH_OPEN : SIDEBAR_DIMENSIONS.ICON_MIN_WIDTH_CLOSED
});

export const listItemTextStyles = (isOpen: boolean) => ({
    opacity: isOpen ? 1 : 0,
    fontSize: '16px',
    marginLeft: isOpen ? SIDEBAR_DIMENSIONS.TEXT_MARGIN_LEFT : '',
    "& .MuiListItemText-primary": {
        fontWeight: 400,
        color: COLORS.Romance,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        lineHeight: '24px',
        ":hover": {
            backgroundColor: "transparent",
        },
    },
    ".MuiListItemButton-root": {
        ":hover": {
            backgroundColor: "transparent",
        },
    }
});

export const arrowContainerStyles = {
    ml: '100px'
};

export const sidebarTitleStyles = {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '12px',
    mt: '-5px',
    fontWeight: 400,
    color: COLORS.Romance,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    lineHeight: '12px'
};

export const modalStyles = {
    height: SIDEBAR_DIMENSIONS.ITEM_HEIGHT,
    borderRadius: 2,
    "&.Mui-selected": {
        backgroundColor: "background.default",
        ":hover": {
            backgroundColor: "background.default",
        },
    },
    ".MuiListItemButton-root": {
        ":hover": {
            backgroundColor: "transparent",
        },
    }
};

export const modalItemTextStyles = {
    "& .MuiListItemText-primary": {
        fontSize: '12px',
        color: COLORS.Romance,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '24px',
    }
};

export const collapseItemStyles = (isOpen: boolean) => ({
    pl: isOpen ? 4 : 0,
    height: SIDEBAR_DIMENSIONS.ITEM_HEIGHT,
    ml: 1,
    borderRadius: 2,
    justifyContent: !isOpen ? "center" : '',
    "&.Mui-selected": {
        backgroundColor: "background.default",
        ":hover": {
            backgroundColor: "background.default",
        },
    },
    ".MuiListItemButton-root": {
        ":hover": {
            backgroundColor: "transparent",
        },
    }
});

export const dropLineStyles = {
    minWidth: "12px",
    position: 'absolute' as const,
    left: '43px',
    mt: 0,
    zIndex: 9999,
};

export const collapseItemIconStyles = (isOpen: boolean) => ({
    minWidth: isOpen ? '40px' : 0
});

export const collapseItemTextStyles = {
    marginLeft: '-10px',
    "& .MuiListItemText-primary": {
        color: COLORS.Romance,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '24px'
    }
};